import React from "react";
import CrmSectionPage from "./CrmSectionPage";

export default function Campaigns() {
  return <CrmSectionPage sectionKey="campaigns" />;
}
